import type {
  FixedService,
  HourlyService,
  PricingNotes,
  TirePriceTables,
} from '../types';

export const pricingNotes: PricingNotes = {
  customerPartsNoWarranty: 'Kliendi enda toodud varuosadega garantii ei kehti.',
  weldingOffered: 'Teostame ka pisemaid keevitustöid.',
  tireUnitFourWheels:
    'Hind kehtib ühe auto rehvivahetusele (4 ratast), kui ei ole märgitud teisiti.',
  estimateOrientation:
    'Orienteeruv hind — lõplik summa kinnitatakse pärast ülevaatust, sõltuvalt vea ulatusest ja töö mahust.',
  inclusionsSoft:
    'Täpne tööde maht (sh tasakaalustus jms) kinnitatakse kohapeal.',
  pricesIncludeVat: 'Hinnad sisaldavad KM.',
};

/** Tire matrices — unit = full vehicle rehvivahetus (4 wheels). */
export const tirePriceTables: TirePriceTables = {
  passenger: {
    steel: [
      { minInch: 13, maxInch: 15, priceEur: 35, label: "Plekkvelg 13'–15'" },
      { minInch: 16, maxInch: 18, priceEur: 40, label: "Plekkvelg 16'–18'" },
    ],
    alloy: [
      { minInch: 14, maxInch: 16, priceEur: 40, label: "Valuvelg 14'–16'" },
      { minInch: 17, maxInch: 18, priceEur: 45, label: "Valuvelg 17'–18'" },
      { minInch: 19, maxInch: 19, priceEur: 50, label: "Valuvelg 19'" },
      { minInch: 20, maxInch: 21, priceEur: 55, label: "Valuvelg 20'–21'" },
      { minInch: 22, maxInch: 23, priceEur: 60, label: "Valuvelg 22'–23'" },
    ],
  },
  vanSuv: {
    // Size-agnostic steel: price always 45€; UI hides size control.
    // min/max kept only for quoteTireChange convenience when size is still passed.
    steel: [
      { minInch: 13, maxInch: 23, priceEur: 45, label: 'Plekkvelg' },
    ],
    alloy: [
      { minInch: 15, maxInch: 15, priceEur: 45, label: "Valuvelg 15'" },
      { minInch: 16, maxInch: 17, priceEur: 50, label: "Valuvelg 16'–17'" },
      { minInch: 18, maxInch: 19, priceEur: 55, label: "Valuvelg 18'–19'" },
      { minInch: 20, maxInch: 21, priceEur: 60, label: "Valuvelg 20'–21'" },
      { minInch: 22, maxInch: 23, priceEur: 70, label: "Valuvelg 22'–23'" },
    ],
  },
};

export const hourlyServices: HourlyService[] = [
  { id: 'remont', title: 'Remonditööd', rateEur: 38 },
  { id: 'diagnostika', title: 'Diagnostika', rateEur: 43 },
];

export const fixedServices: FixedService[] = [
  { id: 'veakoodid', title: 'Veakoodide lugemine', priceEur: 20 },
  { id: 'olivahetus', title: 'Õlivahetus (õli + filter)', priceEur: 30 },
  { id: 'ventiil', title: 'Ventiilivahetus', priceEur: 10 },
  { id: 'rehviparandus', title: 'Rehviparandus nööriga', priceEur: 7 },
  {
    id: 'rehvivahetus-from',
    title: 'Rehvivahetus',
    priceEur: 35,
    isFrom: true,
    switchToTire: true,
  },
];

export const generalPriceRows = [
  { title: 'Rehvivahetus', price: 'al. 35€' },
  { title: 'Remonditööd', price: '38€/h' },
  { title: 'Diagnostika', price: '43€/h' },
  { title: 'Veakoodide lugemine', price: '20€' },
  { title: 'Õlivahetus (õli + filter)', price: '30€' },
  { title: 'Ventiilivahetus', price: '10€' },
  { title: 'Rehviparandus nööriga', price: '7€' },
] as const;

export const HOURLY_MIN = 1.0;
/** Soft UI ceiling only — long jobs can run for weeks; no practical product max. */
export const HOURLY_MAX = 999;
export const HOURLY_STEP = 1.0;
export const HOURLY_DEFAULT = 1.0;
